import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AssessmentContainer, AssessmentNavigation } from './common';
import { Box } from '@material-ui/core';
import { staticImages } from '../../assets/static-images';

class AssessmentStart extends Component {
	constructor(props) {
		super(props);

		this.handleBack = this.handleBack.bind(this);
		this.handleNext = this.handleNext.bind(this);
	}

	handleBack() {
		const { history, previousLink, saveScreenDuration } = this.props;
		saveScreenDuration();
		history.push(previousLink);
	}

	handleNext() {
		const { history, nextLink, saveScreenDuration, setDateTimeStart } = this.props;
		setDateTimeStart();
		saveScreenDuration();
		history.push(nextLink);
	}

	render() {
		return (
			<AssessmentContainer>
				<Box className="box-container">
					<img width="275" height="275" src={staticImages.stopHand} alt="Stop" />
				</Box>
				<AssessmentNavigation type="begin_back" onClick={this.handleBack} />
				<AssessmentNavigation type="begin_next" onClick={this.handleNext} />
			</AssessmentContainer>
		);
	}
}

const mapStateToProps = state => ({
	data: state.data
});

export default connect(mapStateToProps, null)(AssessmentStart);